import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        question: '=',
        formModel: '<',
        sites: '=',
        uibModalInstance: '='
    },
    template
})
export default class {
    constructor ($rootScope, $state, $scope, lodash, Upload, FormFactory,
                 QuestionResource, QuestionPoolResource, MetaFieldGroupResource,
                 TokenService, QuestionService, QuestionConfirmService,
                 ModalService, FormService, ResponseService,
                 FORMS_POOL_ENUM, QUESTIONS_TYPE_ENUM, QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM, toastr, $translate) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.Upload = Upload;
        this.toastr = toastr;
        this.FormFactory = FormFactory;
        this.QuestionResource = QuestionResource;
        this.QuestionPoolResource = QuestionPoolResource;
        this.MetaFieldGroupResource = MetaFieldGroupResource;
        this.QuestionService = QuestionService;
        this.QuestionConfirmService = QuestionConfirmService;
        this.ModalService = ModalService;
        this.FormService = FormService;
        this.ResponseService = ResponseService;
        this.FORMS_POOL_ENUM = FORMS_POOL_ENUM;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM = QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM;

        this.tab = 'general';
        this.questionMetaFields = {};
        this.defaultLanguage = TokenService.getCompanyLanguage();
        const listener = $rootScope.$on('question:reload', () => {
            this.initAnswerValues();
            this.initMatrixValues();
        });
        $scope.$on('$destroy', listener);
    }

    $onInit () {
        const resource = this.question ? angular.copy(this.question) : new this.QuestionResource;
        this.form = this.FormFactory.createFromResource(resource);
        this.canManageQuestion = this.FormService.canManageForm(this.formModel);
        if (this.question) {
            this.initMetaFields();

            // Sort translations to be indexed by language
            if (this.form.model.questionAnswers) {
                this.lodash.forEach(this.form.model.questionAnswers, (answer, key) => {
                    this.form.model.questionAnswers[key].translations = {};

                    this.form.model.questionAnswers[key].translations = this.lodash.reduce(this.form.model.questionAnswersI18ns, (origin, answerI18n) => {
                        if (answerI18n.answerId === answer.id) {
                            if (!origin[answerI18n.language]) {
                                origin[answerI18n.language] = {};
                            }
                            origin[answerI18n.language] = answerI18n;
                        }
                        return origin;
                    }, {});
                });
            }
        }
        else {
            this.form = this.FormFactory.create(new this.QuestionResource, model => model.$save());
            this.form.model.isPartialPoints = true;
        }

        this.QuestionPoolResource.query({ status: this.FORMS_POOL_ENUM.KEYS.ACTIVE, pageSize: 0 }).$promise.then((response) => {
            this.questionPools = response;
        });

        this.MetaFieldGroupResource.query({ pageSize: 0 }).$promise.then((response) => {
            this.metaFieldGroups = response;
        });

        // By default 3 steps are assigned to SCALE type
        this.scaleSteps = 3;

        this.scale = {
            selected: null,
            list: []
        };

        this.matrix = {
            selected: null,
            list: []
        };

        this.models = {
            selected: null,
            list: []
        };

        this.initAnswerValues();
        this.initMatrixValues();

        this.chosenFile = null; // question image file
        this.chosenFiles = []; // answer image files
        this.chosenVideoFile = null;
        this.chosenVideoFiles = [];
        this.initQuestionId();
    }

    initAnswerValues () {
        if (this.form.model.questionAnswers) {
            this.scale.list = [];
            this.scaleSteps = this.form.model.questionAnswers.length;
            this.lodash.forEach(this.form.model.questionAnswers, (item, key) => {
                if (this.isCheckboxOrRadioQuestion()) {
                    this.QuestionService.addItem(this.models);
                }
                else if (this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.SCALE || this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.MATRIX) {
                    if (this.form.model.questionAnswers[key].correctness === this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.NOT_APPLICABLE) {
                        this.scaleSteps = this.form.model.questionAnswers.length - 1;
                        this.form.model.allowNAOption = true;
                    }
                    else {
                        this.QuestionService.addScaleValue(this.scale, key + 1, item.text);
                    }
                }
            });
        }
        else {
            this.form.model.questionAnswers = [];
            this.QuestionService.addItem(this.models);

            this.QuestionService.addScaleValue(this.scale, 1, '1');
            this.QuestionService.addScaleValue(this.scale, 2, '2');
            this.QuestionService.addScaleValue(this.scale, 3, '3');
        }
    }

    initMatrixValues () {
        this.matrix.list = [];
        if (this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.MATRIX) {
            this.lodash.forEach(this.form.model.childQuestionsActiveI18ns, (childQuestion) => {
                if (childQuestion.language === this.defaultLanguage) {
                    this.QuestionService.addMatrixValue(this.matrix, childQuestion.name);
                }
            });
        }
        else {
            this.QuestionService.addMatrixValue(this.matrix);
        }
    }

    initMetaFields () {
        // copy all the existing meta to variable
        this.questionMetaFields = {};
        if (this.form.model.questionMeta) {
            this.questionMetaFields = this.lodash.reduce(this.form.model.questionMeta, (origin, meta) => {
                if (meta.metaFieldValueId) {
                    meta.metaFieldValueId = meta.metaFieldValueId.toString();
                }

                origin[meta.metaFieldId] = meta;
                return origin;
            }, {});
        }
    }

    beforeSave () {
        if (this.formModel && this.formModel.id) {
            this.form.model.formId = this.formModel.id;
        }

        const questionMeta = this.lodash.reduce(this.questionMetaFields, (origin, metaField) => {
            metaField.language = this.defaultLanguage;
            origin.push(metaField);
            return origin;
        }, []);

        this.form.model.questionMeta = angular.copy(questionMeta);

        if (this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT) {
            delete this.form.model.questionAnswers;
        }
        else if (this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.SCALE) {
            this.form = this.QuestionService.assignScaleFieldsBeforeSave(this.form, this.scale);
        }
        else if (this.form.model.type === this.QUESTIONS_TYPE_ENUM.KEYS.MATRIX) {
            this.form = this.QuestionService.assignScaleFieldsBeforeSave(this.form, this.scale);
            this.form = this.QuestionService.assignMatrixFieldsBeforeSave(this.form, this.matrix);
        }

        if (this.form.model.questionAnswers) {
            this.lodash.forEach(this.form.model.questionAnswers, (item, key) => {
                this.form.model.questionAnswers[key].index = key;
            });
        }

        if (!this.isCheckboxOrRadioQuestion() && this.form.model.questionAnswers) {
            this.form.model.questionAnswers = this.form.model.questionAnswers.map(answer => {
                answer.imageFile = null;
                answer.removeImage = true;
                return answer;
            });
        }
    }

    isCheckboxOrRadioQuestion () {
        return this.lodash.includes(
            [this.QUESTIONS_TYPE_ENUM.KEYS.RADIO, this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX],
            this.form.model.type
        );
    }

    save (confirmed = false) {
        this.$rootScope.$broadcast('set.questionSiteIds');
        this.beforeSave();

        let uploadUrl = `${SEED_CORE.ENV.API_URL}form/question`;
        let method = 'POST';

        if (this.form.model.id) {
            uploadUrl = `${SEED_CORE.ENV.API_URL}form/question/${this.form.model.id}`;
            method = 'PUT';
        }

        uploadUrl += confirmed ? '?confirmUpdate=true&expand=sites' : '?expand=sites';

        this.Upload.upload({
            url: uploadUrl,
            data: this.form.model,
            method
        }).then((response) => {
            this.toastr.success(this.$translate.instant('forms.Question successfully saved'));
            this.form.model.sites = response.data.sites || [];
            this.$rootScope.$broadcast('question:sitesUpdated', this.form.model.sites);
            this.uibModalInstance.close(response.data);
        }).catch((response) => {
            this.form.errors = this.ResponseService.parseErrors(response);
            this.handleResponse(response);
        });
    }

    handleResponse (response) {
        const msg = this.QuestionConfirmService.getConfirmationMessage(response);
        if (msg) {
            this.form.cleanErrors();
            this.ModalService.confirm(msg, 'medium').then(() => this.save(true));
            return;
        }
        this.detectTheTab(response);
    }

    detectTheTab (response) {
        const generalTabFields = this.lodash.find(response.data, (item) => {
            return item.field === 'questionPoolId' ||
                item.field === 'questionSiteIds' ||
                item.field === 'categoryId' ||
                item.field === 'questionI18ns' ||
                item.field === 'country' ||
                item.field === 'name' && item.path && item.path === `questionI18ns.${this.defaultLanguage}` ||
                item.field === 'description' && item.path && item.path === `questionI18ns.${this.defaultLanguage}` ||
                item.field === 'language' && item.path && item.path === `questionI18ns.${this.defaultLanguage}` ||
                item.field === 'help' && item.path && item.path === `questionI18ns.${this.defaultLanguage}` ||
                item.field === 'imageFile' && (!item.path || !item.path.startsWith('questionAnswers')) ||
                item.field === 'videoFile' && (!item.path || !item.path.startsWith('questionAnswers')) ||
                item.field === 'videoUrl' && (!item.path || !item.path.startsWith('questionAnswers'))
                ;
        });
        const answerTabFields = this.lodash.find(response.data, (item) => {
            return item.field === 'questionAnswers' ||
                item.field === 'type' ||
                item.field === 'name' && item.path && this.lodash.includes(item.path, 'childQuestions') ||
                item.field === 'text' && item.path && this.lodash.includes(item.path, 'questionAnswers') ||
                item.field === 'points' && item.path && this.lodash.includes(item.path, 'questionAnswers') ||
                item.field === 'correctness' && item.path && this.lodash.includes(item.path, 'questionAnswers') ||
                item.field === 'imageFile' && item.path && this.lodash.includes(item.path, 'questionAnswers') ||
                item.field === 'videoFile' && item.path && this.lodash.includes(item.path, 'questionAnswers') ||
                item.field === 'videoUrl' && item.path && this.lodash.includes(item.path, 'questionAnswers')
                ;
        });
        const metaTabFields = this.lodash.find(response.data, (item) => {
            return item.field === 'questionMetaFieldGroupId' ||
                item.field === 'externalId' ||
                item.field === 'metaFieldId' && item.path && this.lodash.includes(item.path, 'questionMeta') ||
                item.field === 'metaFieldValueId' && item.path && this.lodash.includes(item.path, 'questionMeta') ||
                item.field === 'value' && item.path && this.lodash.includes(item.path, 'questionMeta')
                ;
        });

        if (generalTabFields && generalTabFields.message) {
            this.tab = 'general';
        }
        else if (answerTabFields && answerTabFields.message) {
            this.tab = 'answers';
        }
        else if (metaTabFields && metaTabFields.message) {
            this.tab = 'meta';
        }
    }

    initQuestionId () {
        if (!this.form.model.externalId) {
            this.form.model.externalId = Date.now();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/question/add/index.js